/**
 * B2C feature switches from the build environment (CRA: REACT_APP_*, read at build time).
 *
 * REACT_APP_MAPS_ENABLED - the maps (results "map view", hotel / event / attraction maps). The map provider now
 * needs an API key and billing, so they are OFF unless the build sets REACT_APP_MAPS_ENABLED=true.
 */
export const isMapsEnabled = (): boolean => process.env.REACT_APP_MAPS_ENABLED === 'true';
